<div class="details document-details">
  <div class="product-description">
    <div class="product-document-favorite my-2">
      <label class="product-code" [innerHtml]="product.code| searchHighlight:searchQuery"></label>
      @if (isLoggedIn) {
        <div (click)="addfav = !addfav" (mouseenter)="tooltip = true" (mouseleave)="tooltip = false">
          @if (tooltip) {
            <img (click)="SubscribeDoc(product)"
              [attr.src]="tooltip ? 'icons/icon_star_active.svg' : 'icons/icon_star.svg'" alt="" class="icon-star">
            }
            @if (!tooltip) {
              <img [attr.src]="addfav ? 'icons/icon_star_active.svg' : 'icons/icon_star.svg'" alt=""
                class="icon-star">
            }
            @if (tooltip) {
              <span class="tooltip-AddtoFavorites">Add to favorites</span>
            }
          </div>
        }
      </div>
      <div class="doc-text mb-2" [innerHTML]="product.productGroup| searchHighlight:searchQuery"></div>
      <div class="doc-text mb-2" [innerHTML]="product.docSuppText"></div>
      <div class="doc-text mb-2" [innerHTML]="product.docAddText"></div>
      <div class="doc-desc mb-2 pdp-document-tab-title" [innerHTML]="product.description| searchHighlight:searchQuery">
      </div>
      <div class="doc-text mb-2" [innerHTML]="product.docType"></div>
      @if (product.revision) {
        <div class="doc-text mb-2">Rev : {{product.revision}}</div>
      }
      <!-- <div class=" doc-text mb-2">Release Date : {{product.releaseDate}}</div> -->

    </div>
    <!--  <div class="download-btn-outer"> -->
    @if ((product?.url?.toLowerCase()?.includes('.pdf') || product?.url?.toLowerCase()?.includes('.tif'))) {
      <div class="download-btn-outer"
        >
        <a (click)="downloadPopup(product)" class="btn button">
          Download Document
          <img src="icons/link-grey.svg" class="icon-right">
        </a>
      </div>
    } @else {
      <div class="download-btn-outer">
        <a href={{product.url}} target="_blank" class="btn button button-launch" rel="noopener">
          Launch Video
        </a>
      </div>
    }
  <!--  </div> -->


</div>